export enum ClientConfigurationModalID {
    DETAILS,
    SCOPE,
    POLICY,
    SETTINGS
}
